import {useProjectId} from "../ProjectName";
import {Button, Grid, Menu, MenuItem} from "@mui/material";
import {useState} from "react";
import {api} from "../../../../api/API";
import {useBackgroundAction} from "../../manage/sov/UseBackgroundTask";
import {Loader} from "../../../../misc/Loader";

export function RecalculateCogs(props: {
    type: string;
    anchorEl: HTMLElement | null;
    onOpen(): void;
}) {
    const project = useProjectId();
    const [open, setOpen] = useState(false);

    const result = useBackgroundAction({
        callback: (input: Parameters<typeof api.projects.recalculateFinancials>[0]) => api.projects.recalculateFinancials(input),
        onDone: () => {
            window.location.reload();
        }
    });

    return <>
        <MenuItem onClick={() => {
            props.onOpen();
            setOpen(true);
        }}>Recalc Cogs</MenuItem>

        {open && <Menu open anchorEl={props.anchorEl} onClose={() => setOpen(false)}>
            <Loader {...result} />
            <div style={{padding: 16, maxWidth: 400}}>
                This will recalculate the cost of goods for every logistics item in this project. The page reloads when it is done.
            </div>
            <Grid container spacing={1} justifyContent="flex-end" style={{paddingRight: 10, paddingBottom: 8}}>
                <Grid item>
                    <Button onClick={() => setOpen(false)} size="small">Cancel</Button>
                </Grid>
                <Grid item>
                    <Button disabled={result.loading} onClick={() => result.callback({project: project})} variant="contained" size="small">Recalculate</Button>
                </Grid>
            </Grid>
        </Menu>}
    </>
}
